import { Cabin } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { CabinCategory, IDetailDeck } from './interfaces'

export const useState = (): CabinState => {
  return {
    categories: [],
    cabins: [],
    decks: [],
    type: '',
    category: null,
    cabin: null,
    selectedByUser: false,
    deck: null,
    userChoice: '',
    userChoiceMessage: 'Bitte Kabinennummer eingeben.',
    isCabinLoading: false
  }
}

export interface CabinState {
  categories: CabinCategory[]
  cabins: Cabin[]
  decks: IDetailDeck[]
  type: string
  category: CabinCategory | null
  cabin: Cabin | null
  selectedByUser: boolean
  deck: IDetailDeck | null
  userChoice: string
  userChoiceMessage: string
  isCabinLoading: boolean
}
